var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "fit-content" } }, [
    _c("div", { staticStyle: { display: "flex" } }, [
      _c(
        "div",
        { staticClass: "section form-column" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                "label-width": "133px",
                "label-position": "right"
              }
            },
            [
              _c("span", { staticClass: "title" }),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_CabinSpaceSerialNo") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "1", disabled: true },
                    model: {
                      value: _vm.cabin.allocationSerialNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "allocationSerialNumber", $$v)
                      },
                      expression: "cabin.allocationSerialNumber"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.cabin.cargoType,
                        callback: function($$v) {
                          _vm.$set(_vm.cabin, "cargoType", $$v)
                        },
                        expression: "cabin.cargoType"
                      }
                    },
                    _vm._l(_vm.cargoType4JobSelect, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "span",
                  {
                    staticClass: "blue",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "departure-date-picker",
                      staticStyle: { flex: "1", "margin-right": "5px" },
                      attrs: {
                        no: "etd",
                        value: _vm.cabin.etd,
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      on: { input: _vm.etdChange }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("filterWeek")(_vm.cabin.sailingDay)))
                    ])
                  ],
                  1
                )
              ]),
              _c("el-form-item", [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))
                ]),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { flex: "1", "margin-right": "5px" },
                      attrs: {
                        no: "eta",
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      on: { input: _vm.etaChange },
                      model: {
                        value: _vm.cabin.eta,
                        callback: function($$v) {
                          _vm.$set(_vm.cabin, "eta", $$v)
                        },
                        expression: "cabin.eta"
                      }
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("filterWeek")(_vm.cabin.etaSailingDay))
                      )
                    ])
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SeaExport.PlaceOfReceiptCodeOnBl") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "loadingPort",
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      placeholder: _vm.$t("SeaExport.PlaceHolderPOR"),
                      filterable: "",
                      "default-value": _vm.cabin.loadingPort,
                      "tag-name": "englishName"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.changeDispatchingPlaceCode(p)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.PlaceOfReceiptOnBl") } },
                [
                  _c("el-input", {
                    attrs: { no: "dispatchingPlace" },
                    model: {
                      value: _vm.cabin.dispatchingPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "dispatchingPlace", $$v)
                      },
                      expression: "cabin.dispatchingPlace"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "span",
                  {
                    staticClass: "blue",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c("cargo-advance-select", {
                      ref: "departurePort",
                      staticStyle: { flex: "1" },
                      attrs: {
                        no: "departurePort",
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.cabin.departurePort,
                        "tag-name": "englishName"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.cabin.departurePort = p.value
                          _vm.setPlannerChange(p.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { "padding-left": "2px" },
                        attrs: { no: "transfering" },
                        model: {
                          value: _vm.cabin.transshipment,
                          callback: function($$v) {
                            _vm.$set(_vm.cabin, "transshipment", $$v)
                          },
                          expression: "cabin.transshipment"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")) + " ")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cabin.transshipment,
                      expression: "cabin.transshipment"
                    }
                  ]
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.TransitPort")))]
                  ),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transferPortCode",
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.cabin.transferPortCode
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.cabin.transferPortCode = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDischarge")))]
                  ),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "dischargePort",
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.cabin.dischargePort
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.dischargingPortCodeChange(p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PlaceOfDelivery")))]
                  ),
                  _c("cargo-advance-select", {
                    staticClass: "port-of-delivery-selector",
                    attrs: {
                      no: "deliveryPlace",
                      "popper-class": "port-of-delivery-selector-popper",
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.cabin.deliveryPlace
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.cabin.deliveryPlace = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_PlaceOfDeliveryRegion"))
                    )
                  ]),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "placeOfDeliveryRegion",
                      "select-type": _vm.selectTypeNames.basic_data_Region,
                      filterable: "",
                      "default-value": _vm.cabin.placeOfDeliveryRegion
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.cabin.placeOfDeliveryRegion = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Airline")))]
                  ),
                  _c("el-input", {
                    attrs: {
                      no: "vesselLine",
                      value: _vm.vesselLine,
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ShippingCompany")))]
                  ),
                  _c("cargo-company-select", {
                    ref: "shippingCompany",
                    attrs: {
                      no: "carrierId",
                      "method-params": {
                        companyLob: "seaExport",
                        seaCmp: true,
                        active: true
                      },
                      "default-value": _vm.cabin.carrierId || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.cabin.carrierId = p.value
                        _vm.shippingCompanyChange(p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "bookingAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      filterable: "",
                      "method-params": {
                        bookingAgent: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.cabin.bookingAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.cabin.bookingAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticStyle: { "padding-left": "10px" } }),
      _c(
        "div",
        { staticClass: "section form-column", staticStyle: { width: "400px" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                "label-width": "105px",
                "label-position": "right"
              }
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
              ]),
              _c("booking-sea-eq-data-grid", {
                ref: "bookingSeaEqDataGrid",
                attrs: {
                  no: "bookingSeaEqDataGrid",
                  value: _vm.seaEqList,
                  "container-load-type": "FCL",
                  "is-edit": !_vm.readonly,
                  job: _vm.cabin
                },
                on: { eqQuantityChange: _vm.eqQuantityChangeHandler }
              }),
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.OperationCompany")))]
                  ),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "branchId",
                      "office-id": Number(_vm.cabin.branchId)
                    },
                    on: {
                      change: function(p) {
                        _vm.cabin.branchId = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                [
                  _c("cargo-user-select", {
                    attrs: {
                      no: "routeManager",
                      "method-params": {
                        officeId: _vm.cabin.branchId,
                        category: "role",
                        shape: "seaLine"
                      },
                      "default-value": _vm.cabin.routeManager || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.cabin.routeManager = p.value
                        _vm.txtPlannerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_CabinSpaceNote") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "285px" },
                    attrs: { no: "allocationNote", type: "textarea", rows: 4 },
                    model: {
                      value: _vm.cabin.allocationNote,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "allocationNote", $$v)
                      },
                      expression: "cabin.allocationNote"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("CargoMsg.Cargo_GuidedSellingPrice") }
                },
                [
                  _c("el-input", {
                    attrs: { no: "guideSellingPrice" },
                    model: {
                      value: _vm.cabin.guideSellingPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "guideSellingPrice", $$v)
                      },
                      expression: "cabin.guideSellingPrice"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.FreeDemurrage") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { controls: false, no: "freeStackDays" },
                    model: {
                      value: _vm.cabin.freeStackDays,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "freeStackDays", $$v)
                      },
                      expression: "cabin.freeStackDays"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.FreeDetention") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { controls: false, no: "freeChestRentPeriod" },
                    model: {
                      value: _vm.cabin.freeChestRentPeriod,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "freeChestRentPeriod", $$v)
                      },
                      expression: "cabin.freeChestRentPeriod"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticStyle: { "padding-left": "10px" } }),
      _c(
        "div",
        { staticClass: "section form-column", staticStyle: { width: "400px" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.BookingInfo")))
          ]),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                "label-width": "105px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticClass: "blue",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Vessel")))]
                  ),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "5",
                      "select-type": _vm.selectTypeNames.static_data_Vessel,
                      cache: false,
                      filterable: "",
                      "allow-create": true,
                      "default-value": _vm.cabin.shipName,
                      "static-options": _vm.vesselList
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.onVesselSelectionChange(p)
                      }
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "span",
                  {
                    staticClass: "blue",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Voyage")))]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("cargo-advance-select", {
                      ref: "voyage",
                      attrs: {
                        no: "6",
                        "static-options": _vm.voyages || [],
                        cache: false,
                        "default-value": _vm.cabin.voyage,
                        filterable: "",
                        clearable: "",
                        "allow-create": true,
                        "tag-name": "voyageNo",
                        "tag-value": "voyageNo",
                        "filter-tag-names": ["voyageNo"]
                      },
                      on: {
                        focus: function($event) {
                          return _vm.txtVoyageFocusInHandler()
                        },
                        parentCallBack: function(p) {
                          _vm.onVoyageFlightChange(p)
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.CarrierVoyage") } },
                [
                  _c("el-input", {
                    attrs: { no: "carrierVoyage" },
                    model: {
                      value: _vm.cabin.carrierVoyage,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "carrierVoyage", $$v)
                      },
                      expression: "cabin.carrierVoyage"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "S/O No." } },
                [
                  _c("so-no-input", {
                    attrs: { no: "soNo", disabled: _vm.readonly },
                    model: {
                      value: _vm.cabin.soNo,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "soNo", $$v)
                      },
                      expression: "cabin.soNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.MblNo2") } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "padding-right": "3px"
                      }
                    },
                    [
                      _c("el-input", {
                        class: _vm.cabin.mblNo === "CANCELLED" ? "mbl-red" : "",
                        attrs: { no: "7" },
                        model: {
                          value: _vm.cabin.mblNo,
                          callback: function($$v) {
                            _vm.$set(_vm.cabin, "mblNo", $$v)
                          },
                          expression: "cabin.mblNo"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.BookingNo") } },
                [
                  _c("el-input", {
                    attrs: { no: "9" },
                    model: {
                      value: _vm.cabin.bookingNo,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "bookingNo", $$v)
                      },
                      expression: "cabin.bookingNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.ShippingCompanyContractNo")
                  }
                },
                [
                  _c("el-input", {
                    attrs: { no: "10" },
                    model: {
                      value: _vm.cabin.scNo,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "scNo", $$v)
                      },
                      expression: "cabin.scNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_IMO") } },
                [
                  _c("el-input", {
                    attrs: { no: "11" },
                    model: {
                      value: _vm.cabin.imo,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "imo", $$v)
                      },
                      expression: "cabin.imo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_CarrierCode") } },
                [
                  _c("el-input", {
                    attrs: { no: "carrierCode" },
                    model: {
                      value: _vm.cabin.shipEdiCode,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "shipEdiCode", $$v)
                      },
                      expression: "cabin.shipEdiCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.BookingShipCallSign") } },
                [
                  _c("el-input", {
                    attrs: { no: "12" },
                    model: {
                      value: _vm.cabin.shipCallSign,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "shipCallSign", $$v)
                      },
                      expression: "cabin.shipCallSign"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_AirlineCode") } },
                [
                  _c("el-input", {
                    attrs: { no: "13", disabled: _vm.checkRouteCode },
                    model: {
                      value: _vm.cabin.routeCode,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "routeCode", $$v)
                      },
                      expression: "cabin.routeCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "52",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.cabin.cutOffDate,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "cutOffDate", $$v)
                      },
                      expression: "cabin.cutOffDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.DeclareCutOffDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "53",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.cabin.declarationDate,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "declarationDate", $$v)
                      },
                      expression: "cabin.declarationDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.CYCutOffDate2") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "54",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.cabin.sealingDate,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "sealingDate", $$v)
                      },
                      expression: "cabin.sealingDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.CustomerCyCutOffDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "55",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.cabin.customerSealDate,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "customerSealDate", $$v)
                      },
                      expression: "cabin.customerSealDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.CustomerShutOutDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "customerWithdrawalDate",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.cabin.customerWithdrawalDate,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "customerWithdrawalDate", $$v)
                      },
                      expression: "cabin.customerWithdrawalDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.CustomerClosingTime") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "customerCutOffTime",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.cabin.customerCutOffTime,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "customerCutOffTime", $$v)
                      },
                      expression: "cabin.customerCutOffTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_CabinSpaceRecord") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "285px" },
                    attrs: {
                      no: "allocationRemark",
                      type: "textarea",
                      rows: 4
                    },
                    model: {
                      value: _vm.cabin.allocationRemark,
                      callback: function($$v) {
                        _vm.$set(_vm.cabin, "allocationRemark", $$v)
                      },
                      expression: "cabin.allocationRemark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }